module.exports = __webpack_public_path__ + "img/januca-2019-thumbnail.1ada9444.jpeg";